import type { ReactElement } from 'react';

export type ThinkingDotsProps = {
    /** Announced to screen readers; the dots themselves are decorative. */
    label: string;
};

/** One cycle of the dots' pulse. */
const pulseDuration = '1200ms';

/**
 * Three pulsing dots for a reply that hasn't produced anything yet. Unlike
 * `TypingDots` (the stepped text dots on a running tool call) this is the
 * whole bubble's content, so it gets a status role.
 */
export function ThinkingDots({ label }: ThinkingDotsProps): ReactElement {
    return (
        <span role="status" aria-label={label} className="flex items-center gap-tight">
            {[0, 1, 2].map((index) => (
                <span
                    key={index}
                    aria-hidden
                    className="block size-1.5 animate-pulse rounded-full bg-content-weaker"
                    style={{ animationDuration: pulseDuration, animationDelay: `${index * 0.2}s` }}
                />
            ))}
        </span>
    );
}
